import React, { Component, Fragment, createRef, forwardRef} from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import { Button, notification, Modal, Popover, Switch, DatePicker, Checkbox, Space, Typography } from 'antd';
import { declencherGarantie, fetchConditionOfWarranty } from '../../utils/apiBucherVaslin';
import { faEdit, faFileContract, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import HtmlIncluder from '../HtmlIncluder';
import { withRouter } from "react-router-dom";
import Dropzone from 'react-dropzone';
import './ActivateGuarantee.less';
import { prototype } from 'events';

// Total step number
const maxStep = 2;
const { Text } = Typography;
const fileSize = "5";

class ActivateGuarantee extends Component {

    // constructor(props){
    //     props;
        state = {
            visible: false,
            warrantyStartDate: moment(new Date()),
            dealerCheckCGU: false,
            dealerCheckWarranty: false,
            step: 1,
            confirmationCheckbox: false,
            file:[],
        };

 
    // }


    showModal = () => {
        this.setState({
            visible: true
        });
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            dealerCheckCGU: false,
            dealerCheckWarranty: false,
            step: 1
        });
    };

    declencher = async () => {
        const { intl, refresh, isConnectedDevice, guaranteeIsValidate } = this.props;
        const { warrantyStartDate, file } = this.state;
        this.setState({ visible: false, dealerCheckCGU: false, dealerCheckWarranty: false, step: 1 });
        // Call api
        let { isSuccess, isUnauthorized } = await declencherGarantie(this.props, isConnectedDevice, guaranteeIsValidate, warrantyStartDate, file);
        isSuccess ? (
            // Refresh data
            refresh(),
            // Display success Modal
            notification.success({
                message: intl.formatMessage({ id: 'table.devices.guarantee.success' })
            })
        ) : (
            notification.error({
                message: (isUnauthorized) ?
                    intl.formatMessage({ id: 'error.unauthorized.title' }) :
                    intl.formatMessage({ id: 'table.devices.guarantee.error' }),
                description: (isUnauthorized) ? intl.formatMessage({ id: 'error.unauthorized.message' }) : (
                    <a onClick={() => this.handleRedirect()}>
                        {intl.formatMessage({ id: 'table.devices.guarantee.error.contact' })}
                    </a>
                ),
            })
        )
    };
    /**
     * Method used for dropzone and file management
     */
    handleDropzoneDrop = (acceptedFile) => {
        const files = this.state.file;
        const allFiles = files.concat(acceptedFile);
        this.setState({ file: acceptedFile, dealerCheckWarranty: true });
    };

    showRejectFileModal = () => {
        const { intl } = this.props;

        notification.error({
            duration: 10,
            message: <span dangerouslySetInnerHTML={{
                __html: intl.formatHTMLMessage(
                    { id: 'contact.form.file.sizeLimit.error' },
                    { fileSize: fileSize }
                )
            }}></span>,
        });
    }

    removeFile = (event, index) => {
        event.stopPropagation();
        const copyFiles = this.state.file;
        copyFiles.splice(index, 1);
        this.setState({ files: copyFiles, dealerCheckWarranty: false, confirmationCheckbox: false });
    };

    /**
     * Method used when user confirm modal
     */
    confirm() {
        this.declencher();
    }

    /**
     * Method used to return corresponding label for "Ok" button
     */
    getOkButtonLabel() {
        const { askActivate, warranty } = this.props;
        const { step } = this.state;

        if (!warranty || step === maxStep) {
            // If all displayed step have been completed
            return (askActivate) ? "cgu.accept.guarantee" : "cgu.accept";
        } else {
            // Else, display next step
            return "activateDevice.nextStep";
        }
    }

    handleRedirect = () => {
        const { history } = this.props;
        history.push("/contact");
    }

    // Update validation checkbox value
    async changeValidationCheck() {
        const { confirmationCheckbox, dealerCheckWarranty } = this.state;
        await this.setState({ confirmationCheckbox: !confirmationCheckbox && dealerCheckWarranty ? true : false })
    }

    // Method used to get informations about General Terms of Sales
    getGTS() {
        const { intl } = this.props;
        const gts = {
            label: intl.formatMessage({ id: 'gts.title' }),
            locale: intl.locale,
            link: "",
            linkWarranty:"",
        };
        
        switch (gts.locale) {
            case "fr":
                gts.link = "/templates/pdf/general_terms_of_sales/general_terms_of_sales_french.pdf"
                gts.linkWarranty = "/templates/pdf/conditions_of_warranty/Contract RD-fr.pdf"
                break;
            case "en":
                gts.link = "/templates/pdf/general_terms_of_sales/general_terms_of_sales_english.pdf"
                gts.linkWarranty = "/templates/pdf/conditions_of_warranty/Contract RD-en.pdf"
                break;
            case "de":
                gts.link = "/templates/pdf/general_terms_of_sales/general_terms_of_sales_german.pdf"
                gts.linkWarranty = "/templates/pdf/conditions_of_warranty/Contract RD-de.pdf"
                break;
            case "es":
                gts.link = "/templates/pdf/general_terms_of_sales/general_terms_of_sales_spanish.pdf"
                gts.linkWarranty = "/templates/pdf/conditions_of_warranty/Contract RD-es.pdf"
                break;
            case "it":
                gts.link = "/templates/pdf/general_terms_of_sales/general_terms_of_sales_italian.pdf"
                gts.linkWarranty = "/templates/pdf/conditions_of_warranty/Contract RD-it.pdf"
                break;
            default:
                gts.link = "/templates/pdf/general_terms_of_sales/general_terms_of_sales_english.pdf"
                gts.linkWarranty = "/templates/pdf/conditions_of_warranty/Contract RD-en.pdf"
                break;
        }

        return gts;
    }

    async downloadCoditionOfWarranty(fileName){
            console.log(fileName);
            const url = await fetchConditionOfWarranty(fileName);
    }
    
    render() {
        const { visible, warrantyStartDate, confirmationCheckbox, file } = this.state;
        const { disable, isUpdate, authorizeTransfert, fileName, serial} = this.props;
        const gts = (visible) ? this.getGTS() : null;
        
        

        return (
            <span>
                {isUpdate ?( fileName ?
                    
                    <Popover content={!authorizeTransfert ? <FormattedMessage id="table.devices.impossible" /> : <FormattedMessage id="table.devices.guaranteeDownLoad" />} >
                        <Button htmlType="button" onClick={()=>{this.downloadCoditionOfWarranty(fileName)}}>
                            <FontAwesomeIcon icon={faFileDownload} />
                        </Button>
                    </Popover>
                    :
                    <Popover content={!authorizeTransfert ? <FormattedMessage id="table.devices.impossible" /> : <FormattedMessage id="table.devices.guaranteeUpdate" />} >
                        <Button id={`${serial}`} htmlType="button" onClick={this.showModal} disabled={disable || !authorizeTransfert}>
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                    </Popover>
                    )
                    :
                    <Popover content={!authorizeTransfert ? <FormattedMessage id="table.devices.impossible" /> : <FormattedMessage id="table.devices.guarantee" />} >
                        <Button id={`${serial}`} htmlType="button" onClick={this.showModal} disabled={disable || !authorizeTransfert}>
                            <FontAwesomeIcon icon={faFileContract} />
                        </Button>
                    </Popover>
                }
                <Modal
                    title={(isUpdate ? <FormattedMessage id="table.devices.guaranteeUpdate" /> : <FormattedMessage id="table.devices.guarantee" />)}
                    visible={visible}
                    okText={<FormattedMessage id="common.yes" />}
                    onOk={() => this.confirm()}
                    okButtonProps={{
                        disabled: confirmationCheckbox ? false : true
                    }}
                    cancelText={<FormattedMessage id="common.cancel" />}
                    onCancel={this.handleCancel}
                    bodyStyle={{
                        overflowY: 'hidden',
                        minHeight: '50px',
                        position: 'relative',
                        display: 'block'
                    }}
                    width={"30%"}
                    className="file-upload-form-item"
                >
                    <Fragment >
                        <Text mark><FormattedMessage id="table.devices.guarantee.documentation" /></Text>
                        <br />
                        {gts && (<ul style={{ marginTop: "1em" }}>
                            <li>
                                <a href={gts.linkWarranty} download>
                                    <FormattedMessage id="table.devices.guarantee.documentation.pdf" />
                                </a>
                            </li>
                        </ul>
                        )}

                        <Dropzone
                            className="dropzone"
                            name="file"
                            multiple={false}
                            maxSize={fileSize * 1000000}
                            onDrop={this.handleDropzoneDrop}
                            onDropRejected={this.showRejectFileModal}
                            accept=".pdf"
                        >
                            <Fragment>
                                {(file && file.length > 0) ? (
                                    <div className="file-container">
                                        {file && file.map((fileElement, fileIndex) => (
                                            <button
                                                type="button"
                                                key={fileElement.name}
                                                className="file-name-container"
                                                onClick={(e) => this.removeFile(e, fileIndex)}
                                            >
                                                <span className="file-name">{fileElement.name}</span>
                                                <span className="file-delete">
                                                    <FontAwesomeIcon icon="times-circle" />
                                                </span>
                                            </button>
                                        ))}
                                    </div>
                                ) : null}

                                <div className="dropzone-content">
                                    <span className="upload-icon">
                                        <FontAwesomeIcon icon="file-upload" />
                                    </span>
                                    {/* <span ><FormattedMessage id="contact.form.fileUpload" /></span> */}
                                </div>
                            </Fragment>

                        </Dropzone>
                        <br />

                        <span>{<FormattedMessage id="table.devices.guaranteeDate" />}</span>
                        <DatePicker
                            format='DD/MM/YY'
                            defaultValue={warrantyStartDate}
                            disabledDate={d => d.isAfter(new Date())}
                            disabled={true}
                            onChange={
                                (date, dateString) => {
                                    this.setState({ warrantyStartDate: date, })
                                }
                            } />
                        <br />
                        <span>
                            <Checkbox
                                checked={confirmationCheckbox}
                                onChange={() => this.changeValidationCheck()}
                                style={{ marginRight: "1em", marginTop: "1em" }}
                            />
                            <FormattedMessage id="device.modal.confirm.terms.of.sales" />

                        </span>

                        {/* List of informations link */}
                        <ul style={{ marginTop: "1em" }}>
                            {/* Link to General Terms of Sales */}
                            {gts && (
                                <li>
                                    <a target="_blank" href={gts.link}>{gts.label}</a>
                                </li>
                            )}
                        </ul>
                    </Fragment>
                </Modal>
            </span>
        );
    }
}

ActivateGuarantee.propTypes = {
    askActivate: PropTypes.bool.isRequired, // Si l'utilisateur est le concessionnaire de la machine alors la valeur est à true
    refresh: PropTypes.func,
    intl: intlShape.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    disable: PropTypes.bool,
    isUpdate: PropTypes.bool,
    warranty: PropTypes.bool.isRequired,
    guaranteeIsValidate: PropTypes.bool.isRequired,
    authorizeTransfert: PropTypes.bool,
};

export default injectIntl(withRouter(ActivateGuarantee));